import { AuthContextOutletType } from 'common/types/auth';
import { useOutletContext } from 'react-router-dom';

export function useAuthContext() {
  return useOutletContext<AuthContextOutletType>();
}
